import React from "react";
import "./App.css";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Features } from "./components/Features";
import { Pricing } from "./components/Pricing";
import { FAQ } from "./components/FAQ";
import { RequestDemo } from "./components/RequestDemo";
import { Footer } from "./components/Footer";
import { Payment } from "./components/Payment";
import { Checkout } from "./components/Checkout";
import { DownloadApk } from "./components/DownloadApk";
import { KnowledgeCenter } from "./components/KnowledgeCenter";
import { PrivacyPolicy } from "./components/PrivacyPolicy";
import { TermsOfService } from "./components/TermsOfService";
import { Seo } from "./components/Seo";
import { Toaster } from "./components/ui/toaster";
import { CookieConsent } from "./components/CookieConsent";
import { Routes, Route, Navigate } from "react-router-dom";
import { routes, organizationSchema, softwareSchema, knowledgeCenterSchema } from "./seo";
import { faqData } from "./mock";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqData.map((f) => ({
    "@type": "Question",
    name: f.question,
    acceptedAnswer: { "@type": "Answer", text: f.answer },
  })),
};

const homeSchema = [organizationSchema, softwareSchema, faqSchema];

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={
          <>
            <Seo route={routes.home} schema={homeSchema} />
            <Navbar />
            <Hero />
            <About />
            <Features />
            <Pricing />
            <FAQ />
            <RequestDemo />
            <Footer />
          </>
        } />
        <Route path="/checkout" element={<><Seo route={routes.checkout} /><Checkout /></>} />
        <Route path="/payment" element={<><Seo route={routes.payment} /><Payment /></>} />
        {/* /download-apk is a legacy alias; its canonical points at /download so only one URL ranks */}
        <Route path="/download" element={<><Seo route={routes.download} /><DownloadApk /></>} />
        <Route path="/download-apk" element={<><Seo route={routes.download} /><DownloadApk /></>} />
        <Route path="/knowledge-center" element={<><Seo route={routes.knowledgeCenter} schema={knowledgeCenterSchema} /><KnowledgeCenter /><Footer /></>} />
        <Route path="/tutorial" element={<><Seo route={routes.knowledgeCenter} schema={knowledgeCenterSchema} /><KnowledgeCenter /><Footer /></>} />
        <Route path="/kebijakan-privasi" element={<><Seo route={routes.privacy} /><PrivacyPolicy /></>} />
        <Route path="/privacy-policy" element={<><Seo route={routes.privacy} /><PrivacyPolicy /></>} />
        <Route path="/privacy" element={<><Seo route={routes.privacy} /><PrivacyPolicy /></>} />
        <Route path="/hapus-akun" element={<Navigate to="/kebijakan-privasi#hapus-akun" replace />} />
        <Route path="/delete-account" element={<Navigate to="/kebijakan-privasi#hapus-akun" replace />} />
        <Route path="/syarat-ketentuan" element={<><Seo route={routes.terms} /><TermsOfService /></>} />
      </Routes>
      <Toaster />
      <CookieConsent />
    </div>
  );
}

export default App;
